import { api } from './api';

export interface AdminUserDto {
  id: string;
  name: string;
  email: string;
  username: string;
  status: 'ACTIVE' | 'SUSPENDED' | 'BANNED';
  joinDate: string;
  lastActive: string | null;
  storiesCount: number;
  role: string;
  suspensionReason?: string;
  suspendedUntil?: string;
}

export interface PagedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export interface UserSearchParams {
  page?: number;
  size?: number;
  search?: string;
  status?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export const adminUserService = {
  async getUsers(params: UserSearchParams = {}): Promise<PagedResponse<AdminUserDto>> {
    const queryParams = new URLSearchParams();
    
    if (params.page !== undefined) queryParams.set('page', params.page.toString());
    if (params.size !== undefined) queryParams.set('size', params.size.toString());
    if (params.search) queryParams.set('search', params.search);
    if (params.status) queryParams.set('status', params.status);
    if (params.sortBy) queryParams.set('sortBy', params.sortBy);
    if (params.sortDir) queryParams.set('sortDir', params.sortDir);

    const response = await api.get(`/admin/users?${queryParams}`);
    return response.data;
  },

  async suspendUser(userId: string, reason: string): Promise<void> {
    await api.post(`/admin/users/${userId}/suspend`, { reason });
  },

  async banUser(userId: string, reason: string): Promise<void> {
    await api.post(`/admin/users/${userId}/ban`, { reason });
  },

  async activateUser(userId: string): Promise<void> {
    await api.post(`/admin/users/${userId}/activate`);
  },

  async warnUser(userId: string, message: string): Promise<void> {
    await api.post(`/admin/users/${userId}/warn`, { message });
  }
};